export default function AccountGuide() {
  const steps = [
    {
      step: 1,
      title: '提携金融機関アプリをダウンロード',
      description: 'App StoreまたはGoogle Playから提携金融機関の専用アプリをダウンロードします。',
      icon: 'ri-smartphone-line'
    },
    {
      step: 2,
      title: '必要事項を入力',
      description: 'お名前、住所、電話番号などの必要事項をアプリ内で入力します。本人確認書類（運転免許証またはマイナンバーカード）が必要です。',
      icon: 'ri-edit-line'
    },
    {
      step: 3,
      title: '口座開設完了',
      description: '手続完了メールが届いたら口座開設の申込受付完了です。順次キャッシュカードが届きます。',
      icon: 'ri-check-double-line'
    },
    {
      step: 4,
      title: 'クレジットカードを申込む',
      description: '口座開設後、クレジットカードの申込みが可能になります。公式サイトからお申込みください。',
      icon: 'ri-bank-card-line'
    }
  ];

  return (
    <section className="py-16 bg-[#F0FFF4]">
      <div className="max-w-5xl mx-auto px-4">
        <div className="text-center mb-12">
          <div className="inline-block bg-[#FF9900] text-white text-xs font-bold px-4 py-1.5 rounded-full mb-4">
            クレジットカード申込みの前に必要
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-[#003366] mb-4">
            提携金融機関口座の開設方法
          </h2>
          <p className="text-gray-600">
            このカードは提携金融機関口座保有者限定のカードです。<br className="hidden md:block" />
            まだ口座をお持ちでない方は、アプリで簡単に口座開設できます。
          </p>
        </div>

        {/* メリット */}
        <div className="bg-white rounded-2xl shadow-lg p-8 mb-12">
          <h3 className="text-xl font-bold text-[#003366] mb-6 text-center">
            提携金融機関口座開設のメリット
          </h3>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="text-center">
              <div className="w-16 h-16 bg-[#00A040]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-building-line text-2xl text-[#00A040] w-8 h-8 flex items-center justify-center"></i>
              </div>
              <h4 className="font-bold text-[#003366] mb-2">全国約5,800店舗</h4>
              <p className="text-sm text-gray-600">民間最大級の店舗網で、お近くの店舗が見つかります</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-[#00A040]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-atm-line text-2xl text-[#00A040] w-8 h-8 flex items-center justify-center"></i>
              </div>
              <h4 className="font-bold text-[#003366] mb-2">提携ATMが豊富</h4>
              <p className="text-sm text-gray-600">三菱UFJ銀行、セブン銀行、ローソン銀行、ゆうちょ銀行等で利用可能</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-[#00A040]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-service-line text-2xl text-[#00A040] w-8 h-8 flex items-center justify-center"></i>
              </div>
              <h4 className="font-bold text-[#003366] mb-2">豊富なサービス</h4>
              <p className="text-sm text-gray-600">各種ローン、クレジットカードなど充実したサービスを提供</p>
            </div>
          </div>
        </div>

        {/* 口座開設ステップ */}
        <div className="bg-white rounded-2xl shadow-lg p-8 mb-12">
          <h3 className="text-xl font-bold text-[#003366] mb-8 text-center">
            <i className="ri-smartphone-line text-[#00A040] mr-2 w-6 h-6 inline-flex items-center justify-center"></i>
            アプリで簡単！口座開設の流れ
          </h3>
          <p className="text-center text-gray-600 mb-8">
            来店・郵送不要！アプリの操作のみで口座開設できます
          </p>
          
          <div className="grid md:grid-cols-4 gap-6">
            {steps.map((item, index) => (
              <div key={index} className="relative">
                <div className="bg-[#F0FFF4] rounded-xl p-6 h-full">
                  <div className="w-12 h-12 bg-[#00A040] text-white rounded-full flex items-center justify-center font-bold text-lg mb-4 mx-auto">
                    {item.step}
                  </div>
                  <div className="w-12 h-12 bg-[#00A040]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className={`${item.icon} text-xl text-[#00A040] w-6 h-6 flex items-center justify-center`}></i>
                  </div>
                  <h4 className="font-bold text-[#003366] text-center mb-2 text-sm">{item.title}</h4>
                  <p className="text-xs text-gray-600 text-center">{item.description}</p>
                </div>
                {index < steps.length - 1 && (
                  <div className="hidden md:block absolute top-1/2 -right-3 transform -translate-y-1/2">
                    <i className="ri-arrow-right-line text-[#00A040] text-xl w-6 h-6 flex items-center justify-center"></i>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* アプリダウンロード */}
        <div className="bg-gradient-to-r from-[#00A040] to-[#006030] rounded-2xl p-8 text-white">
          <div className="flex flex-col md:flex-row items-center gap-8">
            <div className="w-full md:w-1/2">
              <h3 className="text-2xl font-bold mb-4">提携金融機関アプリ</h3>
              <p className="text-green-100 mb-6">
                アプリで振込や税金・公共料金払込等、さまざまな取引ができます。<br />
                口座開設と同時にクレジットカード（単体型）もお申し込みいただけます。
              </p>
              <div className="flex flex-wrap gap-4">
                <a
                  href="https://apps.apple.com/jp/app/id6478515222"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-black hover:bg-gray-800 text-white px-6 py-3 rounded-lg flex items-center gap-2 transition-colors cursor-pointer"
                >
                  <i className="ri-apple-fill text-xl w-5 h-5 flex items-center justify-center"></i>
                  <span className="text-sm font-medium">App Store</span>
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=jp.co.jabank.bankingappli"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-black hover:bg-gray-800 text-white px-6 py-3 rounded-lg flex items-center gap-2 transition-colors cursor-pointer"
                >
                  <i className="ri-google-play-fill text-xl w-5 h-5 flex items-center justify-center"></i>
                  <span className="text-sm font-medium">Google Play</span>
                </a>
              </div>
            </div>
            <div className="w-full md:w-1/2">
              <img
                src="https://www.jabank.org/kouza/images/download/img-appplus_pc.png"
                alt="提携金融機関アプリ"
                className="w-full max-w-xs mx-auto"
              />
            </div>
          </div>
        </div>

        {/* 店舗での口座開設 */}
        <div className="mt-8 bg-white rounded-2xl shadow-lg p-8">
          <h3 className="text-xl font-bold text-[#003366] mb-6 text-center">
            <i className="ri-building-line text-[#00A040] mr-2 w-6 h-6 inline-flex items-center justify-center"></i>
            店舗・窓口での口座開設も可能
          </h3>
          <p className="text-center text-gray-600 mb-6">
            相談しながら手続きしたい方、すぐに通帳を受け取りたい方は店舗・窓口へ
          </p>
          <div className="text-center">
            <a
              href="https://map.jabank.org/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-[#00A040] hover:bg-[#008030] text-white font-bold px-8 py-4 rounded-lg transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-map-pin-line w-5 h-5 flex items-center justify-center"></i>
              <span>最寄りの店舗を検索する</span>
            </a>
          </div>
          <p className="text-xs text-gray-500 text-center mt-4">
            ※本人確認書類（運転免許証、マイナンバーカード等）と印鑑をお持ちください
          </p>
        </div>

        {/* 公式リンク */}
        <div className="mt-8 text-center">
          <a
            href="https://www.jabank.org/kouza/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-[#00A040] font-medium hover:underline cursor-pointer"
          >
            <span>提携金融機関口座開設の詳細はこちら</span>
            <i className="ri-external-link-line w-4 h-4 flex items-center justify-center"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
